<template>
  <div class="transition">
    <BasicText size="h5">Veuillez sélectionner un module</BasicText>
    <div class="transition-items">
      <BasicCheckbox
        v-for="item in props.in"
        :key="item.id"
        :label="item.intitule"
        :model-value="estRadionOn(item)"
        @update:model-value="updateOut(item)"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
  import type { ModuleInfo } from '@/features/interface/demande/af/steps/frais/batchUpdate/BatchUpdateType.ts'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types.ts'

  type In = ModuleInfo[]
  type Out = ModuleInfo

  const props = defineProps<CarteProps<In, Out>>()
  const emits = defineEmits<CarteEvents<Out>>()

  const estRadionOn = (module: ModuleInfo) => {
    return props.out?.id === module.id
  }

  const updateOut = (module: ModuleInfo) => {
    emits('outChanged', true, module)
  }
</script>
<style lang="less" scoped>
  @import '@/features/interface/demande/ajouter/cartes/ChoixCarte.less';
</style>
